// storage.ts — طبقة localStorage موحّدة + المفاتيح/الأحداث المُتّفَق عليها عبر التطبيق كلّه.
// هذه المفاتيح والأحداث جزء من «العقد» مع الخادم/الجلسة ولا تُغيَّر بلا تنسيق.
export const AUTH_STORAGE_KEYS = [
	'token',
	'access_token',
	'refresh_token',
	'userId',
	'userName',
	'role_id',
	'is_system_admin',
	'owner_id',
	'price_visible_roles',
	'permissions',
	'me_menu',
	'app_menu_all',
	'smart_permissions_bootstrap_pending',
] as const;

export const PERMISSIONS_BOOTSTRAP_KEY = 'smart_permissions_bootstrap_pending';
export const PERMISSIONS_UPDATED_EVENT = 'smart-permissions-updated';
export const MENU_REFRESH_EVENT = 'smart-menu-refresh';
export const AUTH_EXPIRED_EVENT = 'smart-auth-expired';
export const THEME_PALETTE_KEY = 'smart_theme_palette';

export function readStorage(key: string): string | null {
	try {
		return window.localStorage.getItem(key);
	} catch {
		return null;
	}
}

export function writeStorage(key: string, value: string | number | boolean): void {
	try {
		window.localStorage.setItem(key, String(value));
	} catch {
		// تخزين محلّيّ محجوب/ممتلئ لا يجب أن يُسقط التطبيق.
	}
}

export function removeStorage(key: string): void {
	try {
		window.localStorage.removeItem(key);
	} catch {
		// تجاهل
	}
}

export function readJsonStorage<T>(key: string, fallback: T): T {
	const raw = readStorage(key);
	if (!raw) return fallback;
	try {
		return JSON.parse(raw) as T;
	} catch {
		return fallback;
	}
}

export function writeJsonStorage(key: string, value: unknown): void {
	try {
		window.localStorage.setItem(key, JSON.stringify(value));
	} catch {
		// تجاهل
	}
}

export function hasStoredSession(): boolean {
	return Boolean((readStorage('token') || readStorage('access_token')) && readStorage('role_id'));
}

export function clearAuthStorage(): void {
	AUTH_STORAGE_KEYS.forEach(removeStorage);
}

export function dispatchWindowEvent(name: string): void {
	try {
		window.dispatchEvent(new Event(name));
	} catch {
		// تجاهل
	}
}
